<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kLswIl/tc-custom/9781555847616.jpg?1716663321615" alt="This image is the cover for the book Random Acts of Senseless Violence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Random Acts of Senseless Violence
      </h1>
      <p class="bookDescription body article font2">
        <b>A Publishers Weekly Best Book of the Year: In a dystopian future New York, a girl’s diary chronicles her life as society begins to crumble around her.</b><br/>  <br/> Until recently, Lola Hart’s biggest problem was her annoying little sister. Now the twelve-year-old girl’s once comfortable life is slowly falling apart. Her mother is a teacher, but she’s lost her job. Her father is a writer, but no one is buying his scripts. It’s gotten so bad that they can no longer afford their Manhattan apartment or the tuition for Lola’s exclusive private school.<br/>  <br/> They move to a small apartment near Harlem, and Lola enrolls in public school—but the Harts aren’t alone in their troubles. Riots, fires, TB outbreaks, roaming gangs, and civil unrest have become commonplace, threatening the very fabric of life in New York. In the pages of her diary, Lola documents her family’s attempts to adjust as the city and the country spin out of control.<br/>  <br/> Jack Womack, a winner of the Philip K. Dick Award, has been compared to both William Gibson and Kurt Vonnegut for his vivid prose and unbridled imagination. In this novel, “Womack’s stark vision of the United States’s decline is an uncompromising satire that, perhaps even more than it did in the mid-1990s, forces us to confront a world instantly recognizable as our own” (<i>Los Angeles Review of Books</i>).<br/>  <br/> “A heartrending coming-of-age story. Flecked with black humor, this is speculative fiction at its eerie best.” —<i>Entertainment Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Womack
      </h2>
      
      <p class="authorDescription body article">Jack Womack is the author of <I>Ambient</I>, <I>Terraplane</I>, <I>Heathern</I>, <I>Elvissey</I>, <I>Random Acts of Senseless Violence</I>, <I>Let&rsquo;s Put the Future Behind Us</I>, and <I>Going, Going, Gone</I>. Womack&rsquo;s short stories, have appeared in anthologies edited by Kathryn Cramer (<I>Walls of Fear</I>, &ldquo;Out of Sight, Out of Mind&rdquo;), Ellen Datlow (<I>A Whisper of Blood, </I>&ldquo;Lifeblood&rdquo;) <I>The Year&rsquo;s Best Science Fiction and Fantasy</I>, and <I>Little Deaths, </I>&ldquo;That Old School Tie,&rdquo;), and Don Keller, Ellen Kushner, Delia Sherman (<I>The Horns of Elfland, </I>&ldquo;Audience&rdquo;); as well as in <I>Omni</I> (&ldquo;A Kiss, a Wink, a Grassy Knoll&rdquo;). He has published articles or reviews in <I>Spin</I>, the<I> Washington Post Book World</I>, <I>Artbyte</I>, <I>Science Fiction Eye</I>, <I>Fantasy and Science Fiction</I>, <I>New York Review of Science Fiction</I>, and <I>Suddeutche Zeitung</I> (Munich), and was a contributor to <I>Amok: Fifth Dispatch</I>. He is a cowinner of the Philip K. Dick Award, and has taught writing at the Clarion West workshop, in Seattle. He lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5afa46e9